import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('RentalTravelPolicyModel')
export default class RentalTravelPolicyModel {
  @JsonProperty('id', Number, true) public id: number = -1;
  @JsonProperty('max_price', Number, true) public maxPrice: number = undefined;
  @JsonProperty('car_category', String, true) public carCategory: string = undefined;
}
